import { Component, OnInit, Input } from '@angular/core';
import { CommitteeMeetingDto } from '../../shared/dto/committee-meeting.dto';
import { ControlContainer, NgForm } from '@angular/forms';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-committee-meeting-attendance-edit',
  templateUrl: './committee-meeting-attendance-edit.component.html',
  styleUrls: ['./committee-meeting-attendance-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class CommitteeMeetingAttendanceEditComponent implements OnInit {
  @Input() committeeMeeting: CommitteeMeetingDto;

  constructor() {}

  ngOnInit(): void {}
}
